/* eslint-disable */
import * as msal from '@azure/msal-browser';

let msalApp;

export default {
    async init() {
        // Enforce Singleton
        if (msalApp) return msalApp;

        const config = {
            auth: {
                clientId: '82ee22b7-ba97-4154-ba13-7d8d12faed3f',
                authority: 'https://login.microsoftonline.com/2b7cd331-5fc1-498e-837a-460368566497',
                redirectUri: window.location.origin
            },
            cache: {
                cacheLocation: 'localStorage'
            }
        };

        msalApp = new msal.PublicClientApplication(config);

        // Handle redirect response
        const response = await msalApp.handleRedirectPromise();
        if (response) {
            msalApp.setActiveAccount(response.account);
        }

        return msalApp;
    },

    clientId() {
        if (!msalApp) {
            return null;
        }

        return msalApp.getConfiguration().auth.clientId;
    },

    // By default, MSAL.js adds OIDC scopes (openid, profile, email, offline_access) to any login request
    async login(scopes = []) {
        if (!msalApp) return;

        if (!msalApp.interactionInProgress()) {
            await msalApp.loginRedirect({
                scopes,
                prompt: 'select_account',
                domainHint: '2b7cd331-5fc1-498e-837a-460368566497'
            });
        }
    },

    logout() {
        if (!msalApp) return;

        msalApp.logoutRedirect({
            // postLogoutRedirectUri: 'https://cgs.goldstarfinancial.com/'
        });
    },

    user() {
        if (!msalApp) return null;

        const currentAccounts = msalApp.getAllAccounts();
        if (!currentAccounts || currentAccounts.length === 0) {
            // No user signed in
            return null;
        }

        return currentAccounts[0];
    },

    // By default, request token for itself
    async acquireTokenResponse(scopes = ['api://82ee22b7-ba97-4154-ba13-7d8d12faed3f/Files.Read']) {
        if (!msalApp) return null;

        const accessTokenRequest = {
            scopes,
            account: this.user()
        };

        let tokenRes;
        try {
            tokenRes = await msalApp.acquireTokenSilent(accessTokenRequest);
        } catch (err) {
         
          tokenRes = await msalApp.acquireTokenRedirect(accessTokenRequest);
            
        }

        if (!tokenRes || !tokenRes.accessToken) {
            throw new Error("accessToken missing in response");
      }

      const homeAccountId = tokenRes.account.homeAccountId;
      const azureId = homeAccountId.split('.')[0]; // Take only the first part
      // "View as" (helpers/impersonation.js): azure_id is the acting user - the picked person while viewing as
      // them, else the signed-in one. header.vue re-checks the person with the server on every load and clears
      // imp_azureid when it is refused. The token itself is always the real user's.
      localStorage.setItem('authenticated_azureid', azureId);
      localStorage.setItem('azure_id', localStorage.getItem('imp_azureid') || azureId);
      localStorage.setItem('user_name', tokenRes.account.name);

        return tokenRes;
    },

    clearLocal() {
        if (msalApp) {
            for (let entry of Object.entries(localStorage)) {
                let key = entry[0];
                if (key.includes('login.windows')) {
                    localStorage.removeItem(key);
                }
            }
        }
    }
};
